import React from "react";
import { connect } from "react-redux";

import LookUserInput from "../../../user/lookUserInput";
import LookUserPhoneInput from "../../../user/lookUserPhoneInput";
import LookAddressInput from "../../../ui/lookAddressInput";
import {changeUserInfo} from "../../../../../actions/actionFunctions";

const GroheCartLoginRegisterInputs = (props) => {

  const {inputsValidated, fabricatorData, changeUserInfo} = props;

  const inputFields = {
    "firstName": "assignPopup.newCustomer.placeholders.firstName",
    "lastName": "assignPopup.newCustomer.placeholders.lastName",
    "phoneNumber": "assignPopup.newCustomer.placeholders.phoneNumber1",
    "phone2": "assignPopup.newCustomer.placeholders.phoneNumber2",
    "address1": "assignPopup.newCustomer.placeholders.address1",
    "city": fabricatorData.isCaesarStone ? "assignPopup.newCustomer.placeholders.address2" : "assignPopup.newCustomer.placeholders.city",
    "postal": fabricatorData.isLowes ? "assignPopup.newCustomer.placeholders.postalLowes" : "assignPopup.newCustomer.placeholders.postal",
    "email":     "assignPopup.newCustomer.placeholders.email",
  };

  const setUserInputValue = (property, value) => {
    changeUserInfo({
      [property]: value
    });
  }

  return (
    <div className="gc-form__inputs">
      {Object.keys(inputFields).map(inputKey => {
        switch (inputKey) {
          case "phoneNumber":
            return (
              <div className="gc-form__inputs-block" key={inputKey}>
                <LookUserPhoneInput property={inputKey} inputsValidated={inputsValidated} />
              </div>
            )
          case "address1":
            return (
              <div className="gc-form__inputs-block" key={inputKey}>
                <LookAddressInput property={inputKey}
                                  setInputValue={setUserInputValue}
                                  inputsValidated={inputsValidated} />
              </div>
            )
          default:
            return (
              <div className="gc-form__inputs-block" key={inputKey}>
                <LookUserInput property={inputKey} inputsValidated={inputsValidated} />
              </div>
            )
        }
      })}
    </div>
  )
};

const mapStateToProps = (store) => {
  const fabricatorData = store.fabricatorState;
  return {
    fabricatorData
  };
};

const mapDispatchToProps = {
  changeUserInfo,
};

export default connect(mapStateToProps, mapDispatchToProps)(GroheCartLoginRegisterInputs)
